import { useMemo } from 'react';
import type { FollowUpGroup } from '@/models/template';
import type { FollowUp } from '@/models/report';
import styles from './FollowUpSection.module.css';

interface FollowUpSectionProps {
  followUpGroups: FollowUpGroup[];
  followUp: FollowUp | null;
}

export default function FollowUpSection({
  followUpGroups,
  followUp,
}: FollowUpSectionProps) {
  const displayText = useMemo(() => {
    if (!followUp) return null;

    let label: string | null = null;

    if (followUp.followUpClass) {
      const matchingLabel = followUpGroups
        .flatMap((group) => group.followUpLabels)
        .find((l) => l.followUpClass === followUp.followUpClass);

      if (matchingLabel) {
        label = matchingLabel.label;
      }
      // Fallback: format the class name if not found in template
      if (!label) {
        label = followUp.followUpClass
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(' ');
      }
    }

    if (label && followUp.customValue) {
      return `${label} — ${followUp.customValue}`;
    }
    return label ?? followUp.customValue;
  }, [followUp, followUpGroups]);

  if (!displayText) return null;

  return <div className={styles.followUpNotice}>{displayText}</div>;
}
